// src/Components/checkout/ThankYou.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();
  const location = useLocation();

  // Hooks MUST be top-level (no conditional calls)
  const orderFromState = location?.state?.order || null;
  const orderIdFromState = location?.state?.order_id || null;

  // Optional: allow /thankyou?order_id=123
  const orderIdFromQuery = React.useMemo(() => {
    try {
      const sp = new URLSearchParams(location.search || "");
      return sp.get("order_id");
    } catch {
      return null;
    }
  }, [location.search]);

  const orderId = orderIdFromState || orderIdFromQuery || orderFromState?.id || null;

  React.useEffect(() => {
    // If no order id at all, still show thank you page (don’t crash)
  }, [orderId]);

  return (
    <div style={{ maxWidth: 860, margin: "0 auto", padding: 20 }}>
      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 18,
          background: "#ecfeff",
        }}
      >
        <h1 style={{ margin: 0, fontSize: 22 }}>Thank you!</h1>
        <p style={{ marginTop: 8, marginBottom: 0, fontSize: 14, lineHeight: 1.5 }}>
          Your order has been placed successfully.
          {orderId ? (
            <>
              {" "}
              Your order reference is <b>#{orderId}</b>.
            </>
          ) : null}
        </p>
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            padding: "10px 14px",
            borderRadius: 8,
            border: "1px solid #e5e7eb",
            background: "#fff",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Back to home
        </button>

        <button
          type="button"
          onClick={() => navigate("/orders")}
          style={{
            padding: "10px 14px",
            borderRadius: 8,
            border: "none",
            background: "#111827",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 700,
          }}
        >
          View orders
        </button>
      </div>
    </div>
  );
}
